import { useContext } from 'react'
import { PtSiteCtx } from './CustomSiteWrapperF'

export const CenteredSpinner = (props) => {
  const {LoadingComp} = useContext(PtSiteCtx)

  return <LoadingComp {...props} />
}
